"use client";

import React from "react";
import { ArrowRight, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BookConsultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}